import { handleGetRequest } from "./GetTemplate";
import { handlePostRequest } from "./PostTemplate";
import { handlePutRequest } from "./PutTemplate";
import { handleDeleteRequest } from "./DeleteTemplate";

export const CASH_TRANSACTION_TYPES = [
    { label: "Cash In", value: "in" },
    { label: "Cash Out", value: "out" },
];

export const fetchMyCashShift = () => handleGetRequest("/cash/my-shift");

export const fetchAdminCashHistory = (staffId, type, from, to, clientId, flightNumber) => {
    const params = new URLSearchParams();
    if (staffId) params.set("staffId", staffId);
    if (type) params.set("type", type);
    if (clientId) params.set("clientId", clientId);
    if (flightNumber) params.set("flightNumber", flightNumber);
    if (from && to) {
        params.set("from", from);
        params.set("to", to);
    }
    const qs = params.toString();
    return handleGetRequest(`/cash/admin/history${qs ? `?${qs}` : ""}`);
};

export const fetchAdminCashSummary = (range, from, to, clientId, flightNumber) => {
    const params = new URLSearchParams();
    if (from && to) {
        params.set("from", from);
        params.set("to", to);
    } else if (range) {
        params.set("range", range);
    }
    if (clientId) params.set("clientId", clientId);
    if (flightNumber) params.set("flightNumber", flightNumber);
    const qs = params.toString();
    return handleGetRequest(`/cash/admin/summary${qs ? `?${qs}` : ""}`);
};

export const formatCurrency = (value, currency = "usd") => {
    if (value === null || value === undefined || isNaN(value)) return "-";
    return `${currency === "jmd" ? "J$" : "$"}${Number(value).toFixed(2)}`;
};

// Registers (physical tills) - selected at clock-in, at the start of an
// in-store pickup if the current shift skipped that, or acquired/released
// mid-shift from the Clock In/Out page.
export const fetchCashRegisters = () => handleGetRequest("/cash/registers");

export const createCashRegister = (dispatch, name) => dispatch(handlePostRequest({ name }, "/cash/admin/registers", true, true));

export const updateCashRegister = (id, name) => handlePutRequest({ name }, `/cash/admin/registers/${id}`);

export const deleteCashRegister = (dispatch, id) => dispatch(handleDeleteRequest({}, `/cash/admin/registers/${id}`, true, true));

export const fetchAdminRegisterSummary = (cashRegisterId, range, from, to) => {
    const params = new URLSearchParams();
    if (from && to) {
        params.set("from", from);
        params.set("to", to);
    } else if (range) {
        params.set("range", range);
    }
    const qs = params.toString();
    return handleGetRequest(`/cash/admin/registers/${cashRegisterId}/summary${qs ? `?${qs}` : ""}`);
};

export const submitCashOut = (dispatch, payload) => dispatch(handlePostRequest(payload, "/cash/admin/cash-out", true, true));
